import {Card, CardMedia, Grid} from '@mui/material'
import 'react'

interface PaymentAcknowledgementBannerProps {
    bannerUrl: string,
    alt: string,
}

const PaymentAcknowledgementBanner = (props: PaymentAcknowledgementBannerProps) => {
    const {bannerUrl, alt} = props

    return (
        <Grid item m="auto" xs={10} md={10} hidden={!bannerUrl}>
            <Grid container justifyContent="center">
                <Grid item xs={10} md={6}>
                    <Card sx={{border: `none`, boxShadow: `none`}}>
                        <CardMedia
                            sx={{width: `100%`, objectFit: `contain`}}
                            component="img"
                            image={bannerUrl}
                            alt={alt}
                        />
                    </Card>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PaymentAcknowledgementBanner